import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { listArtifacts } from './client';
import { keys } from './keys';

/**
 * Fetch one workstream's artifacts (Drop 6 / S09) — the Files rail panel's data
 * source (`GET /workstreams/{id}/artifacts`). Keyed by
 * `keys.workstream.artifacts(workstreamId)`, so it refetches when the selected
 * workstream changes and S10's delete can invalidate it to drop the removed card.
 *
 * Honours the shared QueryClient defaults (non-zero `staleTime`, no retry on 4xx);
 * loading/error surface via React Query's standard fields, and errors also route to
 * `reportError` through the shared `QueryCache.onError` sink (queryClient.ts).
 */
export function useArtifacts(workstreamId: string | null) {
  const { getAccessToken } = useAuth();
  return useQuery({
    queryKey: keys.workstream.artifacts(workstreamId ?? ''),
    queryFn: ({ signal }) => listArtifacts(workstreamId as string, { getAccessToken, signal }),
    enabled: workstreamId !== null,
  });
}
